import { render, staticRenderFns } from "./ProvisionList.vue?vue&type=template&id=1017a9db&scoped=true&"
import script from "./ProvisionList.vue?vue&type=script&lang=js&"
export * from "./ProvisionList.vue?vue&type=script&lang=js&"
import style0 from "./ProvisionList.vue?vue&type=style&index=0&id=1017a9db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1017a9db",
  null
  
)

export default component.exports